import RMP from './rmp';

export default RMP;



// WEBPACK FOOTER //
// ./src/containers/Player/RadiantMediaPlayer/index.js